export default "__VITE_ASSET__wH0WRGPI__"